import { render, staticRenderFns } from "./BaseMitMenu.vue?vue&type=template&id=39962587&scoped=true"
import script from "./BaseMitMenu.vue?vue&type=script&lang=js"
export * from "./BaseMitMenu.vue?vue&type=script&lang=js"
import style0 from "./BaseMitMenu.vue?vue&type=style&index=0&id=39962587&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39962587",
  null
  
)

export default component.exports